/**
 * Domain sabitleri.
 *
 * Kaynak: MOD_ERP_DEVIR_DOKUMANI.md — Bolum 3 (domain modeli) ve 4.5 (durum makinesi).
 * Bu dosyadaki hicbir deger "kozmetik" degildir; her biri sahadan gelen bir gercegin
 * karsiligidir. Degistirmeden once devir dokumanindaki gerekceyi okuyun.
 */
/**
 * OPERASYONEL rol — sahada ne is yaptigini soyler.
 *
 * ⚠️ LISTE 30.07.2026'DA MUSTERI CEVABIYLA DEGISTI (SORULAR.md S1).
 *    Kaynak: `Nuh Çimento_Veriler.xlsx` → `Tanımalamalar` sayfasi.
 *
 * Iki yapisal degisiklik:
 *
 * 1) `ekip_basi` ARTIK BIR ROL DEGIL. Musteri birebir soyle dedi:
 *    *"Ekipbasi ve Usta tanimini ayri ayri yapmamaktayiz. Ustalar, yeri
 *    geldiginde ekipbasi gorevini ustlenmektedir. Usta tanimi uzerinden,
 *    bizim belirleyecegimiz kisilere Ekip basi yetkilendirmesi yapilabilir."*
 *    → Rol `usta`, ekip basiligi ise KISI BAZLI BIR YETKI (`Employee.ekipBasiYetkisi`).
 *    Bu, T5'teki "roller akiskandir" ilkesinin somut hali.
 *
 * 2) `muhendis` EKLENDI ve SEF YETKILERININ HEPSINE sahiptir:
 *    *"(Tanim Saha Muhendisi olarak degistirmemiz ve Santiye Sefine verdigimiz
 *    yetkilerin hepsine sahip olmalidir.)"*
 *    → K1'i dogrudan etkiler: onay artik yalniz sefte degil.
 *
 * ⚠️ Izolasyon tanimlari BILINCLI OLARAK YOK: *"Izolasyon ile alakali tum
 *    tanimlari kaldirmaliyiz. ERP sisteminde yer alamamalidir."*
 */
export const ROLES = [
    'sef',
    'muhendis',
    'formen',
    'usta',
    'isg',
    'idari',
    'operator',
    'depocu',
    'proje_muduru',
    /**
     * MUSTERI YETKILISI — Nuh/Akcansa tarafindaki kisi (07.09.2026).
     *
     * ⚠️ SAHA ROLU DEGIL, IZLEYICIDIR. Mod'un kadrosundan biri degil; panelde
     *    yalniz dort sayfa gorur (pano · gunluk rapor · kurulu iskeleler ·
     *    arsiv) ve hicbir adimi yurutemez. `SEF_YETKILI_ROLLER`e ASLA girmez.
     *
     * ⚠️ ERISIM YINE CALISAN KAYDINDAN gelir (CLAUDE.md "Erisim = calisan
     *    kaydi, ayri tablo YOK"): musteri yetkilisinin de kendi santiyesinde
     *    bir `employees` satiri olur. Ayri bir erisim tablosu acmak, iki listenin
     *    zamanla ayrismasi demekti.
     */
    'musteri',
];
/** Insan-okur rol etiketleri — arayuz ve mail ayni adi kullansin diye tek yerde. */
export const ROL_ETIKET = {
    sef: 'Şantiye Şefi',
    muhendis: 'Saha Mühendisi',
    formen: 'Formen',
    usta: 'Usta',
    isg: 'İSG',
    idari: 'İdari',
    operator: 'Operatör',
    depocu: 'Depocu',
    proje_muduru: 'Proje Müdürü',
    musteri: 'Müşteri Yetkilisi',
};
/**
 * Rol etiketi — rol NULL olabilir (admin'in saha calisani kaydi olmayabilir).
 * Her ekranda cast yapmak yerine tek yardimci.
 */
export function rolEtiket(rol) {
    return rol ? (ROL_ETIKET[rol] ?? rol) : '—';
}
/**
 * SEF YETKISI TASIYAN ROLLER — is onayi, tanim yonetimi, rapor gonderimi.
 *
 * ⚠️ `muhendis` burada, cunku musteri "sefin yetkilerinin HEPSI" dedi.
 *    Devir dokumani da K1'i *"onayi ucuncu kisi — tekniker veya MUHENDIS,
 *    genelde santiye sefi — verir"* diye tanimliyordu; yeni cevap bunu
 *    dogruladi.
 */
export const SEF_YETKILI_ROLLER = ['sef', 'muhendis'];
/**
 * SISTEM rolu — operasyonel rolden AYRIDIR ve onunla dikeydir.
 *
 * NEDEN AYRI: `admin` Nuh'un organizasyon semasinda YOKTUR; devir dokumani Bolum 3.1
 * bir super-admin tanimlamaz. Admin bir saha rolu degil, sistemi yoneten kisidir
 * (birden cok santiyeye bakar, kullanici acar/kapatir, rol atar).
 * Operasyonel taksonomiyi kirletmemek icin ayri tutuluyor.
 *
 * `admin` ⊃ `sef`: adminin sefin YAPABILDIGI her seyi yapabilmesi acik bir istektir.
 * Bu ust-kume iliskisi tek yerde, `sefYetkisiVarMi()` icinde tanimlidir.
 */
export const SISTEM_ROLLERI = ['admin', 'kullanici'];
/**
 * Kimlik: TELEFON NUMARASI + PAROLA. Harici bir saglayici (Google vb.) YOKTUR.
 *
 * NEDEN TELEFON: saha calisani telefonunu bilir, e-postasini bilmeyebilir —
 * `Employee.telefon` zaten devir dokumani Bolum 8.1'de var. Ayrica kisi basina
 * tekildir, yani K1 ("kuran kendi isini onaylayamaz") ve K5 ("sorumluluk
 * tiklayanda") icin gereken BIREYSEL kimligi dogal olarak saglar.
 *
 * NEDEN HARICI SAGLAYICI YOK: OAuth AG GEREKTIRIR. Cimento fabrikasinin icinde
 * sinyal yoktur (T1 offline-first). Parola dogrulamasi ilk giriste bir kez ag
 * ister; sonrasinda uzun omurlu oturum + yerel PIN ile cevrimdisi acilir.
 */
/**
 * Bolum 4.5 — ana durum makinesi.
 * giris -> kesif -> hazirlik -> kurulum -> kontrol -> ayakta -> (revize | sokum) -> kapali
 */
export const JOB_STATUSES = [
    'giris', // kesif bekliyor
    'kesif', // kesif yapildi; izin & malzeme bekleniyor
    'hazirlik', // izin + malzeme tamam, kuruluma hazir
    'kurulum', // saha calismasi suruyor
    'kontrol', // "ben kurdum" dendi, sef onayinda
    'ayakta', // KURULU — teslim edildi, henuz sokulmedi
    'revize', // kurulu iskele uzerinde degisiklik suruyor
    'sokum', // sokum fazi suruyor
    'kapali', // sokuldu, malzeme iade/birakildi
    'ertelendi', // yapilamadi, YENIDEN PLANLANACAK
    /**
     * IPTAL — is bir daha yapilmayacak.
     *
     * ⚠️ 30.07.2026 musteri istegi: *"Tanimi acildiktan sonra, IPTAL veya
     *    ertelenme durumlari da yasanabiliyor, bu seceneklerde SM ve SS
     *    uzerinden isaretlenebilir olmalidir."*
     *
     * ERTELEME'den farki: erteleme "sonra yapacagiz", iptal "yapmayacagiz".
     * Ayri durum olmasi sart, cunku ertelenen is bir gun geri gelir ve
     * ikisini tek durumda toplamak "bu is neden bekliyor" sorusunu
     * cevaplanamaz hale getirir.
     */
    'iptal',
];
/**
 * DURUM ETIKETLERI — MUSTERININ DILIYLE (istek 07.08.2026):
 * "Kuruldu" · "Söküldü" · "Revizyon". Sistemin durum adlari degil, ISIN
 * BASINA NE GELDIGI okunuyor.
 *
 * ⚠️ BURADA, cunku ayni etiket UC yerde gorunuyor: pano tablosu, disa aktarim
 *    (Excel/PDF) ve arsiv. Panoda yerel bir sozlukte yasarken disa aktarim
 *    kendi cevirisini yazmak zorunda kalirdi — ayni durumun iki adi olurdu ve
 *    musteriye giden dosya ekrandakinden farkli konusurdu.
 */
export const JOB_STATUS_ETIKET = {
    giris: 'Keşif bekliyor',
    kesif: 'İzin & malzeme',
    hazirlik: 'Kuruluma hazır',
    kurulum: 'Kurulum sürüyor',
    kontrol: 'Kontrol bekliyor',
    ayakta: 'Kuruldu',
    revize: 'Revizyon',
    sokum: 'Söküm sürüyor',
    kapali: 'Söküldü',
    ertelendi: 'Ertelendi',
    iptal: 'İptal',
};
export function durumEtiket(durum) {
    return durum ? (JOB_STATUS_ETIKET[durum] ?? durum) : '—';
}
/**
 * ISIN O ANDAKI TIPI — tablodaki "TİP" sutunu.
 *
 * ⚠️ Faz tipi DEGIL, DURUMDAN turetilir ve bilincli boyledir: bir isin omrunde
 *    kurulum + n revize + sokum fazi bulunabilir; sutun "su an ne yapiliyor"
 *    sorusunu cevaplar. Kapanmis is (`kapali`) "Kurulum" gorunur — omru
 *    kurulumla baslamistir ve artik surmekte olan bir faz yoktur.
 *
 * Disa aktarim suzgeci de AYNI turetmeyi kullanir; aksi halde ekranda
 * "Kurulum" gorunen is, "kurulum" secili disa aktarimda cikmayabilirdi.
 */
export function isTipi(durum) {
    if (durum === 'sokum')
        return 'sokum';
    if (durum === 'revize')
        return 'revize';
    return 'kurulum';
}
export const IS_TIPI_ETIKET = {
    kurulum: 'Kurulum',
    revize: 'Revize',
    sokum: 'Söküm',
};
/** Bir isin omrundeki calisma bloklari. v9 karari: tek is kaydi + faz kutulari. */
export const PHASE_TYPES = ['kurulum', 'revize', 'sokum'];
/** Bolum 4.5 — sokum faz alt durumlari. */
/**
 * SOKUM FAZ DURUMLARI.
 *
 * ⚠️ `atandi` 03.08.2026'da eklendi — revizedeki ile ayni gerekce. Faz DOGRUDAN
 *    `basla` ile aciliyordu: sef ekibi seciyor, sistem "baslandi" sayiyordu.
 *    Ekip kendi "emri aldim" onayini veremiyordu ve sokum is emri kagidinin
 *    hangi asamada isteneceginin yeri yoktu.
 *
 * `atandi` adiminda ekip iki yoldan birini secer: onceki is emriyle devam ya
 * da YENI sokum is emri fotografini yukle (devir dokumani §6.6: "Kagit fotosu
 * — sokum is emri kagidi, simdi veya sonra").
 */
export const SOKUM_STATUSES = ['atandi', 'basla', 'devam', 'temiz', 'iade'];
/**
 * GERİ ALINMIŞ SÖKÜM EMRİ. Faz silinmez, bu durumla kapanır ve kayıtta kalır
 * (bkz. `FazService.sokumGeriAl`). Bir akış adımı DEĞİLDİR; o yüzden
 * `SOKUM_STATUSES` içinde yok.
 */
export const SOKUM_GERI_ALINDI = 'iptal';
/**
 * İŞİN GEÇERLİ SÖKÜM FAZI — geri alınmış olanlar hariç, en son açılan.
 *
 * ⚠️ BİR İŞTE BİRDEN ÇOK SÖKÜM FAZI OLABİLİR. Söküm emri geri alınınca faz
 *    `iptal` olarak kalır ve yeni emir ikinci bir faz açar. 21.09.2026'ya kadar
 *    üç yer bu soruyu üç ayrı biçimde cevaplıyordu. Faz açma kontrolü geri
 *    alınmış fazı "devam ediyor" saydı ve Nuh'ta 5 iskele için yeni söküm emri
 *    açılamadı (müşteri bildirimi). Anlık görüntü sırasız "ilk söküm fazını"
 *    alıyordu, yani ikinci emirde eski ekibi görecekti.
 */
export function gecerliSokumFazi(fazlar) {
    return fazlar
        .filter((f) => f.tip === 'sokum' && f.durum !== SOKUM_GERI_ALINDI)
        .reduce((son, f) => (!son || f.sira > son.sira ? f : son), undefined);
}
/** Bolum 4.5 — revize faz alt durumlari. `onay` YALNIZ sef tarafindan verilir (K1). */
/**
 * REVIZE FAZ DURUMLARI.
 *
 * ⚠️ `atandi` 01.08.2026'da eklendi. Onceden faz DOGRUDAN `aldim` ile aciliyordu:
 *    sef ekibi seciyor, sistem "alindi" sayiyordu. Ekranda "Revizeyi aldim"
 *    basligi vardi ama altindaki dugme "Revizeye basladik" diyordu — baslik ile
 *    dugme BIR KAYMISTI ve ekip kendi "aldim" onayini hic veremiyordu.
 *
 *    Ayrim gercek: "aldim" = isi gordum/kabul ettim, "basladik" = sahadayiz.
 *
 * ESKI KAYITLAR `aldim`de duruyor; onlar icin bir adim ilerlemis gorunur ve
 * dogrusu da budur — o ekipler isi zaten almisti.
 */
export const REVIZE_STATUSES = ['atandi', 'aldim', 'basladi', 'bitti', 'onay'];
/** Bolum 6.6 — revizyon turleri. */
export const REVIZE_TURLERI = [
    'yukseltme',
    'alcaltma',
    'kat_ekleme',
    'kat_cikarma',
    'balkon_konsol',
    'diger',
];
/** K4 + K5 — izin bir kez alinir, yenileme yok; override opt-in'dir ve engellemez. */
export const IZIN_DURUMLARI = ['alindi', 'override'];
/** Bolum 6.11 — sokum sonrasi malzemenin akibeti. Hurda AYRI PROSESTIR (K12). */
export const MALZEME_AKIBETLERI = ['depoya_iade', 'bolgede_birakildi'];
/**
 * K8 — her fotograf bir is + adim + zamana baglidir. Basibos galeri YOKTUR.
 * Bu liste fotografin baglanabilecegi TUM adimlardir; disinda bir deger reddedilir.
 */
export const PHOTO_STEPS = [
    // kurulum fazi
    'is_emri', // K3: soft baslangic, HARD kapanis
    'kesif', // coklu keşif fotografi
    'izin', // musteri imzali guvenli calisma izni
    'kurulum', // kurulum sirasinda
    'kontrol_formu', // K2: yasal kagit formun fotografi (dijital checklist YOK)
    'yesil_kart', // K2: Mod Scafftag "Safe for Use"
    'kurulu_iskele', // K2: yesil kart gorunecek sekilde, coklu aci
    // rutin kontrol
    'rutin_kontrol', // 7 gunluk periyodik kontrol
    // revize fazi
    'revize', // revize sonrasi durum
    // sokum fazi
    /** Sokum is emri kagidi — KURULUM is emrinden AYRI belge (§6.6). */
    'sokum_is_emri',
    'sokum', // sokum tamamlandi
    'bos_alan', // alan temizligi — ZORUNLU
];
/** Hangi adim hangi faza ait — K8 dogrulamasinda kullanilir. */
export const PHOTO_STEP_PHASE = {
    is_emri: 'kurulum',
    kesif: 'kurulum',
    izin: 'kurulum',
    kurulum: 'kurulum',
    kontrol_formu: 'kurulum',
    yesil_kart: 'kurulum',
    kurulu_iskele: 'kurulum',
    rutin_kontrol: 'kontrol',
    revize: 'revize',
    sokum_is_emri: 'sokum',
    sokum: 'sokum',
    bos_alan: 'sokum',
};
/**
 * Bolum 6.1a — pano kovalari. Kova = filtre (sayiya tiklayinca hangi isler oldugu gorulur).
 * "Kontrolde" v9'da ayrildi: sefin KENDI aksiyon kuyrugu, "yapimda" ile karismamali.
 */
export const BUCKETS = {
    kesif_bekleyen: ['giris'],
    hazirlikta: ['kesif', 'hazirlik'],
    yapimda: ['kurulum', 'revize', 'sokum'],
    kontrolde: ['kontrol'],
    tamamlanan: ['ayakta', 'kapali'],
};
export const BUCKET_LABELS = {
    kesif_bekleyen: 'Keşif bekleyen',
    hazirlikta: 'Hazırlıkta',
    yapimda: 'Yapımda',
    kontrolde: 'Kontrolde',
    tamamlanan: 'Tamamlanan',
};
/**
 * Bolum 3.5 — Nuh unite taksonomisi. K9: bu liste SABITTIR, yalniz sef (admin) yonetir.
 * v1 seed degeri; uretimde `units` tablosundan gelir.
 */
export const NUH_UNITELERI = [
    'Farin',
    'Fırın',
    'Değirmen',
    'Kırıcı',
    'Kömür',
    'AQC',
    'Liman',
    'Tras',
    'WHR',
    'Agrega',
    'Silo',
    'Diğer',
];
/** Bolum 3.5 — is emri arka yuzundeki "yapilmama nedeni" kutulari. */
export const YAPILAMADI_NEDENLERI = [
    'personel_yetersiz',
    'zaman_yetersiz',
    'malzeme_yetersiz',
    'is_iptali',
    'isletme_kaynakli',
    'diger',
];
/** Bolum 7 — "Bugun dikkat gerektiren" siniflari. Kural motoru Faz 6'da. */
export const ATTENTION_LEVELS = ['kritik', 'uyari', 'bilgi'];
/** Bolum 4.2 — semantik renk token'lari. Dekoratif DEGIL; anlam haritasi uretimde korunur. */
export const COLOR_TOKENS = {
    navy: '#1F3B63', // marka / birincil aksiyon
    crit: '#B4362B', // KRITIK — akisi durduran, guvenlik/kanit eksigi
    warn: '#9C6A08', // UYARI — verimlilik/darbogaz
    ok: '#1C7346', // tamamlandi / onaylandi / guvenli
    wait: '#54657A', // devam ediyor / bekliyor (notr)
    stok: '#544598', // malzeme / depo / sokum-revize fazi
    info: '#1C6C82', // bilgi / kontrol bekliyor
};
//# sourceMappingURL=enums.js.map